import {internal_authenticator} from "@/store/auth/internal_authenticator";

export const authenticator = internal_authenticator;